<template><div><h2 id="kapitel-1-benutzerfuhrung" tabindex="-1"><a class="header-anchor" href="#kapitel-1-benutzerfuhrung"><span>Kapitel 1. Benutzerführung</span></a></h2>
<p>Dieser Teil beschreibt die Benutzerführung in funtrade.</p>
</div></template>


